<template>
	<div>
		<el-card v-show="isEdit">
			<div style="display: flex;">
				<el-button style="margin-left: auto;" @click="isEdit = false">返回列表</el-button>
			</div>
		</el-card>
		<el-card style="margin:18px 0px">
			<div v-show="!isEdit">
				<el-table ref="multipleTable" :data="communityList" tooltip-effect="dark" style="width: 100%">
					<el-table-column prop="id" label="ID" width="50">
					</el-table-column>
					<el-table-column align="center" label="封面">
						<el-image slot-scope="scope" style="width: 80px; height: 80px" :src="scope.row.media"></el-image>
					</el-table-column>
					<el-table-column prop="title" label="图文标题">
					</el-table-column>
					<el-table-column prop="create_time" :formatter="$f.timeFormat" label="创建时间" show-overflow-tooltip>
					</el-table-column>
					<el-table-column align="center" label="管理" width="200">
						<template slot-scope="scope">
							<el-button @click="articleEdit(scope.row)">编辑</el-button>
							<el-popconfirm style="margin-left: 5px;" confirmButtonText='确定' cancelButtonText='取消' @confirm="topicDel(scope.row.id,scope.$index)"
							 icon="el-icon-info" iconColor="red" title="确定删除？">
								<el-button slot="reference" type="danger">删除</el-button>
							</el-popconfirm>
						</template>
					</el-table-column>
				</el-table>
				<el-pagination @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pagesize" layout="total,prev,pager,next"
				 :total="communityLength">
				</el-pagination>
			</div>
			<!-- 编辑 -->
			<div v-show="isEdit">
				<el-form ref="form" :model="form" label-width="80px">
					<el-row>
						<el-col :span="7">
							<el-form-item label="标题" prop="title">
								<el-input v-model="form.title"></el-input>
							</el-form-item>
							<el-form-item label="封面">
								<el-upload ref="uUpload" class="avatar-uploader" :headers="headers" :action="action" :on-success="uploadSuccess">
									<img v-if="form.media" :src="form.media" class="avatar">
									<i v-else class="el-icon-plus avatar-uploader-icon"></i>
								</el-upload>
							</el-form-item>
						</el-col>
						<el-col :span="15">
							<el-form-item>
								<editor-bar ref="editor" @change="change" v-model="form.content"></editor-bar>
							</el-form-item>
							<el-form-item>
								<el-button type="primary" :loading="btnLoading" :disabled="btnDisabled" @click="onSubmit">提交</el-button>
							</el-form-item>
						</el-col>
					</el-row>
				</el-form>
			</div>
		</el-card>
	</div>
</template>

<script>
	import EditorBar from '../../components/wangeditor/index.vue';
	export default {
		components: {
			EditorBar
		},
		data() {
			return {
				action: this.$H.domain + "common/uploadFile",
				headers: {
					token: this.$store.state.userInfo.token
				},
				btnLoading: false,
				btnDisabled: false,
				currentPage: 1,
				pagesize: 0,
				communityList: [],
				communityLength: 0,
				form: {
					title: '',
					media: '',
					content: ''
				},
				topicClassList: [],
				isEdit: false
			}
		},
		created() {
			this.getArticleList();
		},
		methods: {
			articleEdit(e) {
				this.isEdit = true;

				this.form.id = e.id;
				this.form.title = e.title;
				this.form.media = e.media;
				this.form.content = e.content;
				this.$refs.editor.setTxt(e.content);
			},
			getArticleList(class_id) {
				this.$H
					.get("post/articleList", {
						page: this.currentPage
					})
					.then((res) => {
						this.communityList = res.result.data;
						this.pagesize = res.result.per_page;
						this.communityLength = res.result.total;
					})
			},
			handleCurrentChange(currentPage) {
				this.currentPage = currentPage;
				this.getArticleList();
			},
			handleCommand(command) {
				this.getArticleList(command.cate_id);
			},
			topicDel(id, index) {
				this.$H.post("post/del", {
					id: id
				}).then(res => {
					if (res.code == 200) {
						this.communityList.splice(index, 1);
						this.$message.success('删除成功');
					}
				})
			},
			onSubmit() {
				this.btnLoading = true;
				this.btnDisabled = true;

				if (!this.form.title) {
					this.$message.error("标题不能为空");
					this.btnLoading = false;
					this.btnDisabled = false;
					return;
				}

				if (!this.form.media) {
					this.$message.error("请上传封面");
					this.btnLoading = false;
					this.btnDisabled = false;
					return;
				}
				if (!this.form.content) {
					this.$message.error("图文内容不能为空");
					this.btnLoading = false;
					this.btnDisabled = false;
					return;
				}
				this.$H.post("post/editPost", this.form).then(res => {
					if (res.code === 200) {
						this.$refs.form.resetFields();
						this.form.content = "";
						this.form.media = "";
						this.$refs.uUpload.clearFiles();
						this.$refs.editor.clear();

						this.$message.success(res.msg)

						this.isEdit = false;
						this.getArticleList();
					}

					this.btnLoading = false;
					this.btnDisabled = false;
				})
			},
			uploadSuccess(e) {
				this.form.media = e.result.url;
			},
			change(html) {
				this.form.content = html;
			}
		}
	}
</script>

<style>
	.el-dropdown-link {
		cursor: pointer;
		color: #409EFF;
	}

	.el-icon-arrow-down {
		font-size: 12px;
	}

	/* 上传 */
	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 150px;
		height: 150px;
		line-height: 150px;
		text-align: center;
	}

	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}
</style>
